<template>
    <div class="home">
        <img alt="NBA logo" src="../assets/nbalogo.png" />
    </div>
</template>

<script>
    export default {
        name: "LogoComponent",
    };
</script>